<template>
  <modal-factory />
  <Nav v-if="!route.meta.hideChrome" />
  <router-view />
  <Footer v-if="!route.meta.hideChrome" />
</template>

<script>
import { computed, reactive } from 'vue';
import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router';

import Footer from './components/Elements/Footer.vue';
import ModalFactory from './components/Factory/ModalFactory.vue';
import Nav from './components/Elements/Nav.vue';

export default {
  name: 'Home',
  components: {
    Footer,
    ModalFactory,
    Nav,
  },
  setup() {
    const route = useRoute();

    const siteData = reactive({
      title: 'Indicoo - Ganhe dinheiro indicando profissionais de confiança',
      description: 'Ganhe dinheiro indicando profissionais de confiança',
    })

    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: 'description',
          content: computed(() => siteData.description),
          property: 'og:description',
        },
        {
          name: 'og:title',
          content: computed(() => siteData.title),
        },
        {
          name: 'og:image',
          content: 'http://www.indicoo.com.vc/img/indicoo.jpg',
        },
        {
          name: 'og:type',
          content: 'website',
        },
      ],
    })

    return {
      route,
    };
  },
};
</script>

<style lang="scss">
</style>
